import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import _ from "lodash";
import styled from "styled-components";

import EditLabModal from "components/modals/edit-lab-modal";
import { Breadcrumb, Button, Container, Frame, Row, RowWrapper } from "components/ui-kit/styled-templates";

import { resolveFileUrl } from "constants/config";

import LabsAPI from "api/labs-api";
import UniversityApi from "api/university-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import useDeviceParams from "hooks/useDeviceParams";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";

import { EModals, ERoles } from "types/enums";

const LabPublicPage = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const { labId } = useParams();
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);
    const navigate = useNavigate();
    const { isDesktop } = useDeviceParams();
    useBodyBackground(`white`);

    const { universityId, details: lab, rooms } = useStorageListener(`labs.${labId}`, {});
    const university = useStorageListener(`universities.${universityId}.details`, {});
    const labs = useStorageListener((state) => _.values(state?.labs) ?? []);

    const photos = _.get(lab, `photos`, []);
    const photosPagination = usePagination(photos, { perPage: 4 });
    const {
        visibleItems: visiblePhotos,
        isFirstPage: isFirstPhotoPage,
        isLastPage: isLastPhotoPage,
        handleNextPage,
        handlePrevPage,
    } = photosPagination;

    const handlers = {
        editLab: () => {
            ModalsService.showModal(EModals.CreateLab, { mode: `edit`, data: _.find(labs, { id: labId }) });
        },
    };

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);

    // @ts-ignore
    useEffect(async () => {
        if (!lab) {
            try {
                await LabsAPI.getLabInfo(labId);
            } catch (error) {
                // navigate(`/search`);
            }
        }
    }, [labId, lab]);
    // @ts-ignore
    // useEffect(() => !dormitory && RoomsApi.getDormitoryRooms(labId), [labId, dormitory]);
    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    return (
        <>
            {role === ERoles.Admin && <EditLabModal />}

            <Container>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("6gblpnfxl4n")}</Breadcrumb.Item>
                    <Breadcrumb.Item to="/universities">{t("xkyhi6ytzll")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
            </Container>
            <Row extra={`width: inherit; background: #F4F4F4;`}>
                <Container extra={`align-items: flex-start;`}>
                    <LabHeaderRowWrapper lab={lab}>
                        <h1>{_.get(lab, `name`, `...`)}</h1>
                        {/*<Row extra={`gap: 16px;`}>*/}
                        {/*    <Link to={role === ERoles.Guest ? `/login` : `/create-booking/${labId}`}>*/}
                        {/*        <Button>Оставить заявку</Button>*/}
                        {/*    </Link>*/}
                        {/*    /!* <Button variant="outlined">Написать отзыв</Button> *!/*/}
                        {/*</Row>*/}
                    </LabHeaderRowWrapper>
                    <NavMenuWrapper>
                        {[
                            { text: isRu ? `Общая информация` : 'General information', hash: `main-info` },
                            // { text: `Комнаты`, hash: `rooms` },
                            // // { text: `Мероприятия`, hash: `events` },
                            // { text: `Условия заселения`, hash: `rules` },
                            // { text: `Документы`, hash: `documents` },
                        ].map((item, index) => (
                            <a href={`#${item?.hash}`} style={{color: '#723DD3'}} key={index}>
                                {item?.text}
                            </a>
                        ))}
                    </NavMenuWrapper>
                </Container>
            </Row>
            <Container extra={`align-items: flex-start; margin-bottom: 50px;`}>
                {role === ERoles.Admin && (
                    <Button extra="margin: 25px 0;" onClick={handlers.editLab}>
                        {t("37lhc6a6nl")}
                    </Button>
                )}
                <h2 id="main-info">{t("a1q3ajlcwce")}</h2>
                <Row extra={`width: 100%; gap: 32px; flex-direction: row; @media (max-width: 991px) { flex-direction: column; };`}>
                    <MainInfo.Photo src={resolveFileUrl(_.get(lab, `photos[0]`, ``))} />
                    <MainInfo.DetailsWrapper>
                        {[
                            {
                                title:isRu ? `Название` : 'Name',
                                text: _.get(lab, `name`),
                                link: lab?.link,
                            },
                            {
                                title: isRu ? `Город` : 'City',
                                text: _.get(lab, `city`),
                            },
                            // {
                            //     title: `Сайт`,
                            //     text: _.get(lab, `name`),
                            //     link: lab?.link
                            // },
                            {
                                title: isRu ? `Год основания` : `Establishment year`,
                                text: _.get(lab, `establishmentYear`),
                            },

                            // {
                            //     title: `Питание`,
                            //     text: MEAL_PLAN_OPTIONS.find((i) => i?.value === _.get(dormitory, `main-info.mealPlan`))?.label,
                            // },
                            // {
                            //     title: `Адрес`,
                            //     text: `${_.get(dormitory, `main-info.street`, `...`)}, ${_.get(dormitory, `main-info.houseNumber`, `...`)}`,
                            // },
                            {
                                title: isRu ? `Краткое описание ` : `Short description`,
                                text: _.get(lab, `shortDescription`),
                            },
                        ].map((item, index) => (
                            <MainInfo.DetailsItem key={index}>
                                <div>{item?.title}</div>
                                {item?.text && <strong>{item?.text}</strong>}
                                <a href={item?.link} style={{display: 'block',wordBreak: 'break-all'}} >{item?.link}</a>
                            </MainInfo.DetailsItem>
                        ))}
                    </MainInfo.DetailsWrapper>
                </Row>
                <RowWrapper extra={`margin-top: 56px; @media (max-width: 991px) { width: 100vw; margin-left: -7vw; overflow-x: scroll; };`}>
                    {isDesktop && <Gallery.SvgArrow direction="left" isActive={!isFirstPhotoPage} onClick={handlePrevPage} />}
                    <Row
                        extra={`width: 100%; gap: 0 27px; @media (max-width: 991px) { width: max-content; > * { &:first-child { margin-left: 7vw; }; &:last-child { margin-right: 7vw; }; }; };`}
                    >
                        {(isDesktop ? visiblePhotos : photos).map((item: string, index: number) => (
                            <Gallery.Photo
                                key={index}
                                src={resolveFileUrl(item)}
                                onClick={() =>
                                    ModalsService.showModal(EModals.OverlayedGallery, {
                                        photos,
                                        currentPhotoNumber: index,
                                    })
                                }
                            />
                        ))}
                    </Row>
                    {isDesktop && <Gallery.SvgArrow direction="right" isActive={!isLastPhotoPage} onClick={handleNextPage} />}
                </RowWrapper>

                <h2 id="rules">{t("sg5td8pg8ll")}</h2>
                <h3>{t("1fyx2l2hi9gh")}</h3>
                <Frame extra={`max-width: 96vw; white-space: pre-line;`}>{lab?.description}</Frame>

                {lab?.rules == undefined || lab?.rules == "" ? null : (
                    <>
                        <h3>{t("dntbtpqcbn")}</h3>
                        <Frame extra={`max-width: 96vw; white-space: pre-line;`}>{lab?.rules}</Frame>
                    </>
                )}

                <Contacts.Wrapper>
                    <h3>{t("z447wsb2vmg")}</h3>
                    <Contacts.Row>
                        <div>
                            <div>{t("7tjlvmmh2p")}</div>
                            <div>{lab?.admin?.name}</div>
                        </div>
                        <div>
                            <div>{t("fb802bi8377")}</div>
                            <div>{lab?.admin?.phone}</div>
                        </div>
                        <div>
                            <div>{t("mxp8y0xrq6o")}</div>
                            <a href={`mailto:${lab?.admin?.email}`} target="_blank" className="link" rel="noreferrer">
                                {lab?.admin?.email}
                            </a>
                        </div>
                    </Contacts.Row>
                </Contacts.Wrapper>

                {/* <Contacts.Wrapper extra={`width: min-width;`}>
                    <h3>Контакты службы поддержки</h3>
                    <Contacts.Row>
                        <div>
                            <div>Телефон</div>
                            <div>8-800-707-71-61</div>
                        </div>
                        <div>
                            <div>Электронная почта</div>
                            <a href={"mailto:info@mst22.ru"} target="_blank" >info@mst22.ru</a>
                        </div>
                    </Contacts.Row>
                </Contacts.Wrapper> */}
            </Container>
        </>
    );
};

const HeaderRowWrapper = styled(RowWrapper)<{ dormitory: Object }>`
    ${({ theme, dormitory }) => _.isEmpty(_.get(dormitory, `main-info.name`)) && `color: ${theme.red}`};

    @media (max-width: 991px) {
        flex-direction: column;
        h1 {
            margin: 20px 0;
            line-height: 56px;
        }

        div {
            margin: 0 0 32px 0;
        }
    }
`;

const LabHeaderRowWrapper = styled(RowWrapper)<{ lab: Object }>`
    ${({ theme, lab }) => _.isEmpty(_.get(lab, `name`)) && `color: ${theme.red}`};

    @media (max-width: 991px) {
        flex-direction: column;
        h1 {
            margin: 20px 0;
            line-height: 56px;
        }

        div {
            margin: 0 0 32px 0;
        }
    }
`;

const DocumentWrapper = styled(Frame)`
    flex-direction: row;
    cursor: pointer;
    margin-bottom: 5px;

    &:before {
        content: "";
        width: 30px;
        height: 30px;
        background: url("${require(`assets/icons/dropzone-file.svg`).default}") no-repeat center center / contain;
        margin-right: 12px;
    }
`;

const Contacts = {
    Wrapper: styled(Frame)`
        width: inherit;
        padding: 32px;
        box-sizing: border-box;
        border-radius: 8px;
        background: #f4f4f4;
        align-items: flex-start;
        gap: 5px;
        margin-top: 56px;

        h3 {
            margin-top: 0;
        }
    `,
    Row: styled(Row)`
        gap: 10px;
        align-items: flex-start;

        > * {
            display: flex;
            flex-direction: column;
            gap: 8px;

            > * {
                &:nth-child(2) {
                    font-weight: 600;
                }
            }
        }

        .link {
            color: ${({ theme }) => theme.blue};
        }

        @media (max-width: 991px) {
            flex-direction: column;
        } ;
    `,
};

const Gallery = {
    Wrapper: styled(Frame)``,
    Photo: styled(Frame)<{ src: string }>`
        width: 276px;
        height: 195px;
        border-radius: 8px;

        background: url("${({ src }) => src}") no-repeat center center / cover;
    `,
    SvgArrow: styled.svg.attrs((props) => {
        return {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: (
                <>
                    <defs>
                        <style>{`.cls-1{fill:none;}`}</style>
                    </defs>
                    <g id="wrapper">
                        <rect className="cls-1" width="24" height="24" />
                    </g>
                    <path d="M14.55,12,11.2,9.1,6.78,5.32a1.29,1.29,0,0,1-.51-1.18,1.28,1.28,0,0,1,2.12-.81l2.32,2,6.51,5.57a1.27,1.27,0,0,1,.53,1.37,1.67,1.67,0,0,1-.44.72q-4.48,3.87-9,7.7a1.26,1.26,0,0,1-1.81-.13,1.28,1.28,0,0,1,.18-1.84L14.3,12.2Z" />
                </>
            ),
        };
    })<{ direction: `left` | `right`; isActive: boolean }>`
        ${({ direction }) => direction === `left` && `transform: rotate(180deg);`}

        width: 30px;
        height: 30px;

        cursor: pointer;

        path {
            fill: ${({ theme, isActive }) => (isActive ? theme.blue : theme.grey)};
        }
    `,
};

const MainInfo = {
    Photo: styled(Frame)<{ src: string }>`
        width: 100%;
        max-width: 87vw;
        height: 380px;
        flex: 1;
        border-radius: 12px;
        background: url("${({ src }) => src}") no-repeat center center / cover;

        @media (max-width: 991px) {
            max-height: 180px;
            flex: unset;
        }
    `,
    DetailsWrapper: styled(Frame)`
        width: 100%;
        max-width: 87vw;
        min-height: 380px;
        flex: 1;
        border-radius: 12px;
        background: ${({ theme }) => theme.lightblue};

        padding: 32px;
        box-sizing: border-box;

        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;

        gap: 5px;

        @media (max-width: 991px) {
            gap: 15px;
        }
    `,
    DetailsItem: styled(Frame)`
        width: calc(50% - 3px);
        align-items: flex-start;
        font-size: 15px;
        line-height: 20px;

        a {
            color: ${({ theme }) => theme.blue};
            font-weight: 600;
        }

        strong {
            margin: 8px 0 16px;
            min-height: 20px;
        }

        @media (max-width: 991px) {
            width: 100%;
        }
    `,
};

const NavMenuWrapper = styled(Row)`
    gap: 5px 40px;
    color: #0d5adc;
    margin-bottom: 40px;
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
    flex-wrap: wrap;
    justify-content: flex-start;

    > * {
        cursor: pointer;
    }
`;

export default LabPublicPage;
